var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('section',{staticClass:"main-page-new__subscription"},[_c('s-subscription',_vm._b({},'s-subscription',_vm.content,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }